import React from "react";
import { useCoastguard } from "@cofano/coastguard2-frontend-client";
import { CircularProgress, Paper } from "@mui/material";

export default function AsyncLoadingComponent({ children }: { children: React.ReactNode }) {
	const { instance: { isInitialized, isAuthenticationLoading } } = useCoastguard();

	if (isInitialized && !isAuthenticationLoading) {
		return <>{children}</>;
	} else {
		return (
			<Paper
				square
				sx={{
					height: "100%",
					width: "100%",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
				}}
			>
				<CircularProgress color="primary" size={30} />
			</Paper>
		);
	}
}
